var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{ active: _vm.active, 'disabled':_vm.isDisabled }},[_c('a',{attrs:{"href":("#" + _vm.anchor),"target":"_self"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }